<template>
  <div class="component-form-button">
    <a-button
      class="save-button"
      v-show="submitIsShow"
      type="primary"
      shape="round"
      @click="$emit('onSubmit')"
    >
      保存
    </a-button>
    <a-button
      class="cancel-button"
      shape="round"
      @click="$emit('onCancel')"
    >
      返回
    </a-button>
  </div>
</template>
<script>
export default {
  props: {
    submitIsShow: {
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.component-form-button {
  height: 80px;
  line-height: 80px;
  background: #f9f9fc;
  margin: 0 -24px;
  padding: 0 24px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .save-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
  .cancel-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
}
</style>
